import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { eur, Loading } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import BackNav from "@/components/BackNav";

export default function CambioFiori() {
  const [flowers, setFlowers] = useState(null);
  const [config, setConfig] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    api.get("/flowers").then((r) => setFlowers(r.data)).catch(() => setFlowers([]));
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  if (!flowers || !config) return <Loading />;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 space-y-10" data-testid="page-cambio-fiori">
      <BackNav />

      <div className="max-w-2xl">
        <p className="eyebrow mb-2">Servizio</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-navy mb-4">Cambio fiori</h1>
        <p className="text-body leading-relaxed">
          Portiamo fiori freschi a ogni visita: scegli la composizione che preferisci tra le nostre
          proposte. Il Mazzo di Margherite ({eur(config.flower_standard_price)}) è sempre incluso
          nell'intervento; le altre composizioni hanno un piccolo supplemento.
        </p>
      </div>

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {flowers.map((f) => (
          <div key={f.id} className="card-soft overflow-hidden" data-testid={`flower-card-${f.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <img src={f.image} alt={f.name} className="w-full aspect-[4/3] object-cover" loading="lazy" />
            <div className="p-5">
              <div className="flex items-baseline justify-between gap-2 mb-1">
                <p className="font-semibold text-navy">{f.name}</p>
                <p className="font-serif text-xl text-navy">{eur(f.price)}</p>
              </div>
              <p className="text-sm text-body leading-relaxed">{f.description}</p>
            </div>
          </div>
        ))}
      </div>

      <p className="text-xs text-muted-soft leading-relaxed max-w-2xl" data-testid="seasonality-note">
        Il colore e le varietà possono variare in base alla disponibilità e alla stagionalità.
        Puoi indicare una preferenza nelle note al momento della richiesta: faremo il possibile per rispettarla.
      </p>
      <p className="text-xs text-muted-soft leading-relaxed max-w-2xl -mt-6" data-testid="florist-choice-note">
        Le composizioni floreali vengono realizzate con fiori freschi e di stagione. La scelta delle varietà
        e dei colori è affidata al professionista, in base alla disponibilità del momento.
      </p>

      <div className="card-ivory p-6 sm:p-8 flex items-center justify-between gap-4 flex-wrap">
        <div>
          <p className="font-semibold text-navy">Cambio fiori — singola uscita</p>
          <p className="text-sm text-muted-soft">{eur(config.single_visit_price)} con Mazzo di Margherite incluso</p>
        </div>
        <Link
          to={user ? "/checkout?type=singola" : "/accedi"}
          data-testid="cambio-fiori-cta"
          className="btn-primary"
        >
          Procedi <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
